import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=6adceb9a&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=6adceb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adceb9a",
  null
  
)

export default component.exports